module.exports = __webpack_public_path__ + "img/icon8.3e129915.png";